import React, { useState, useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import {
  MAutocomplete,
  MTextField,
  MDatePicker,
  ResponsiveFormContainer,
} from "@app/components";
import { useEquipmentMide, useUser } from "@services/servicesGenericsTables";
import { MODES_OPTIONS } from "@app/types/generics.types";
import { useFormContext } from "react-hook-form";

interface AnalysisFormProps {
  mode: string;
}

const AnalysisBetaTotalPPForm = ({ mode }: AnalysisFormProps) => {
  const { userList } = useUser();
  const isView = mode === MODES_OPTIONS.VIEW;
  const { equipmentMideListFiltered, loading } = useEquipmentMide();
  const { watch, setValue, getValues } = useFormContext();

  useEffect(() => {
    if (getValues("equipment")) return;

    const equipment = equipmentMideListFiltered.find(
      (equipment) => equipment.codigo === "3002"
    );
    setValue("equipment", equipment || undefined);
  }, [equipmentMideListFiltered]);

  return (
    <>
      <Grid item xs={12} my={2}>
        <Typography variant="tagText">
          {"Spill-over Beta Total Partículas de Polvo"}
        </Typography>
      </Grid>
      <ResponsiveFormContainer columns={4}>
        <MAutocomplete
          name="analyst"
          options={userList}
          label="Seleccione un analista"
          getOptionLabel={(option) => option.username || ""}
          validation={{ required: "El analista es requerido" }}
          disabled={isView}
        />
        <MDatePicker
          name="date"
          pickerType="date"
          label="Fecha calibración"
          validation={{ required: "La fecha es requerida" }}
          disabled={isView}
        />
        <MAutocomplete
          key={JSON.stringify(watch("equipment"))}
          name="equipment"
          options={equipmentMideListFiltered}
          label="Contador Proporcional Alfa-Beta"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}` || ""
          }
          loading={loading}
          disabled={isView}
        />
      </ResponsiveFormContainer>

      <Grid item xs={12} my={3}></Grid>
      <ResponsiveFormContainer columns={3}>
        <MTextField
          name="cpm_of_the_alpha_pattern_in_the_beta_win"
          label="cpm del patrón Alfa en la ventana Beta (cpm)"
          placeholder="cpm del patrón Alfa en la ventana Beta (cpm)"
          type="number"
          validation={{
            required: "La cpm del patrón Alfa en la ventana Beta es requerida",
          }}
          fullWidth
          disabled={isView}
        />
        <MTextField
          name="cpm_of_the_alpha_pattern_in_the_alfa_win"
          label="cpm del patrón Alfa en la ventana Alfa (cpm)"
          placeholder="cpm del patrón Alfa en la ventana Alfa (cpm)"
          type="number"
          validation={{
            required:
              "La cpm del patrón Alfa en la ventana Alfa (cpm) es requerida",
          }}
          fullWidth
          disabled={isView}
        />
        <MTextField
          name="total_counting_time_alpha_pattern_in_total_detectors"
          label="Tiempo total de contaje del patrón Alfa en el total de detectores (min)"
          placeholder="Tiempo total de contaje del patrón Alfa en el total de detectores (min)"
          type="number"
          validation={{
            required:
              "La Tiempo total de contaje del patrón Alfa en el total de detectores (min) es requerida",
          }}
          fullWidth
          disabled={isView}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default AnalysisBetaTotalPPForm;
